import React from 'react'
import { ParallaxLayer } from '@react-spring/parallax'
import './style.scss';
import { headerBackgroundImage } from './headerBackgroundImages';
import { animated, useSpring } from 'react-spring';

function Header() {
  
  const TextAnimation = useSpring({
    reverse: false,
    loop: false,
    from: {  marginTop: '-10vh', opacity: 0 },
    to: { marginTop: '0vh', opacity: 1 },
    config: { duration: 1000}
  })

  return (
    <div className='header-container'>
      <div className='header-background-gradient header-background' />
      {
        headerBackgroundImage.map((prop, idx) => 
          <ParallaxLayer offset={0} speed={prop.speed} key={idx}>
            <div className={`header-background header-${prop.class}`} />
          </ParallaxLayer>
        )
      }

        <ParallaxLayer offset={0} speed={-4}>
          <animated.div className='header-text-placeholder' style={TextAnimation}>
            <div className='header-text-container'>
              <p className='header-title'>
                HELLO!
              </p>
              <p className='header-tagline'>
                Welcome to my website
              </p>
            </div>
          </animated.div>
        </ParallaxLayer>
    </div>
  )
}

export default Header
